

import React from 'react';
// import { Link } from 'react-router-dom';
// import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as specialistActions from '../../actions/specialistActions';
import * as SVGICONS from '../../images/img/images';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	Modal,
} from 'react-bootstrap';
var radioStyle = {
	height: 16,
	width: 18
}
class ConsultationAddress extends React.Component {

	constructor(props, context) {
		super(props, context);
	}
	componentWillMount() {
	}
	componentDidMount() {

	}
	componentWillReceiveProps(nextProps) {
	}

	componentDidUpdate(nextProps, nextState) {
	}

	render() {
		var otherConsultationRecord = this.props.otherConsultationAddress

		return (

			<Modal show={this.props.openModal} onHide={this.props.hideConsultationModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hideConsultationModal} /> */}
				</Modal.Header>
				<Modal.Body>

					<div className="container-fluid">

						{otherConsultationRecord ? otherConsultationRecord.map((option, index) => <div key={index} style={{ marginBottom: 35 }} className="row">
							<div className="col-lg-2">
								{option.data._id == this.props.presentConsultationId ? < input style={radioStyle} type="radio" name="consult" defaultValue={"1"} defaultChecked /> : <input style={radioStyle} type="radio" name="consult" />}
							</div>
							<div className="col-lg-4">{option.data.addressLineOne ? option.data.addressLineOne + ',' : ''}{option.data.addressLineTwo ? option.data.addressLineTwo + ',' : ''}{option.data.city ? option.data.city + ',' : ''}{option.data.state ? option.data.state + ',' : ''}
								{option.data.country ? option.data.country : ''}</div>
							<div className="col-lg-6"><button type="button" className="btn btn-block btn-warning" onClick={this.props.goToCalendarPageFromOtherConsulatation.bind(this, option.data._id)}>Book Now</button></div>
						</div>) : ''}

					</div>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >


		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {

	};
}

//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ConsultationAddress);

